"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressSection = void 0;
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _Localization = require("../Localization");
var _components = require("../components");
var _SharedStyledComponents = require("../components/SharedStyledComponents");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _models = require("../models");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const StyledSingleLineLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(6)
}));
const StyledSingleLineAddress = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(5)
}));
const SectionTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(3),
  fontWeight: 'bold'
}));
const AddressSection = props => {
  const {
    configAddress,
    actualValues,
    useUpperCaseAddress
  } = props;
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const {
    data: formatAddressFields
  } = (0, _globalApiClientReact.useGetAddressFormat)('SingleLine');
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const canCreate = configAddress?.operations?.create?.isEnabled;
  const canUpdate = configAddress?.operations?.update?.isEnabled;
  const canDelete = configAddress?.operations?.delete?.isEnabled;

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
  const canEdit = Boolean(canCreate || canUpdate || canDelete);
  const formatedAddress = actualValues?.address?.zipcode ? (0, _utils.getOptionLabelSingleLine)(0, actualValues.address, formatAddressFields ?? _utils.defaultAddressFormat) : null;
  const fieldsForValidateInSearch = (0, _utils.getCorrectFieldsForValidate)(configAddress);
  const singleLineAddress = formatedAddress ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSingleLineLabel, {
      variant: "caption",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.Address_SearchedAddress,
        id: _models.TranslationKey.Address_SearchedAddress
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSingleLineAddress, {
      variant: "body1",
      children: formatedAddress
    })]
  }) : null;
  const getAddressAutocomplete = () => {
    if (configAddress?.searchOptions?.isEnabled) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
        margin: "0 auto 25px",
        maxWidth: 500,
        style: {
          order: configAddress.searchOptions.displayOrder
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.AddressAutocomplete, {
          ...configAddress,
          searchedFields: fieldsForValidateInSearch,
          isEditable: canEdit
        }), singleLineAddress]
      });
    }
    return null;
  };
  const addressAutocomplete = getAddressAutocomplete();
  const sectionOrder = (0, _utils.getLowestDisplayOrder)(configAddress);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledGridItem, {
    size: {
      xs: 12
    },
    style: {
      order: sectionOrder ?? undefined
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SectionTitle, {
      variant: "subtitle1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressTitle,
        id: _models.TranslationKey.AddressTitle
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12
      },
      style: {
        order: configAddress?.searchOptions?.displayOrder
      },
      children: addressAutocomplete
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.SelectFormFieldByConfig, {
      name: "address.country",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressCountry,
        id: _models.TranslationKey.AddressCountry
      }),
      placeholder: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressCountry_Placeholder,
        id: _models.TranslationKey.AddressCountry_Placeholder
      }),
      ...configAddress?.country,
      isMandatory: configAddress?.country?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.zipcode,
      isEditable: !!(canEdit && configAddress?.zipcode?.isEditable),
      name: "address.zipcode",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressZipcode,
        id: _models.TranslationKey.AddressZipcode
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressZipcode_Tooltip,
        id: _models.TranslationKey.AddressZipcode_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressZipcode_Placeholder),
      isAddressMatchRequired: configAddress?.zipcode?.validation?.isAddressMatchRequired,
      isMandatory: configAddress?.zipcode?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.streetAddress,
      name: "address.streetAddress",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressStreetAddress,
        id: _models.TranslationKey.AddressStreetAddress
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressStreetAddress_Placeholder),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressStreetAddressTooltip,
        id: _models.TranslationKey.AddressStreetAddressTooltip
      }),
      isAddressMatchRequired: configAddress?.streetAddress?.validation?.isAddressMatchRequired,
      isEditable: !!(canEdit && configAddress?.streetAddress?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.streetAddress?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.city,
      name: "address.city",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressCity,
        id: _models.TranslationKey.AddressCity
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressCity_Tooltip,
        id: _models.TranslationKey.AddressCity_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressCity_Placeholder),
      isAddressMatchRequired: configAddress?.city?.validation?.isAddressMatchRequired,
      isEditable: !!(canEdit && configAddress?.city?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.city?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.province,
      name: "address.province",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressProvince,
        id: _models.TranslationKey.AddressProvince
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressProvince_Tooltip,
        id: _models.TranslationKey.AddressProvince_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressProvince_Placeholder),
      isAddressMatchRequired: configAddress?.province?.validation?.isAddressMatchRequired,
      isEditable: !!(canEdit && configAddress?.province?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.province?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.delivery,
      name: "address.delivery",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDelivery,
        id: _models.TranslationKey.AddressDelivery
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDelivery_Tooltip,
        id: _models.TranslationKey.AddressDelivery_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressDelivery_Placeholder),
      isEditable: !!(canEdit && configAddress?.delivery?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.delivery?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.delivery2,
      name: "address.delivery2",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDelivery2,
        id: _models.TranslationKey.AddressDelivery2
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDelivery2_Tooltip,
        id: _models.TranslationKey.AddressDelivery2_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressDelivery2_Placeholder),
      isEditable: !!(canEdit && configAddress?.delivery2?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.delivery2?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.delivery3,
      name: "address.delivery3",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDelivery3,
        id: _models.TranslationKey.AddressDelivery3
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDelivery3_Tooltip,
        id: _models.TranslationKey.AddressDelivery3_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressDelivery3_Placeholder),
      isEditable: !!(canEdit && configAddress?.delivery3?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.delivery3?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.area,
      name: "address.area",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressArea,
        id: _models.TranslationKey.AddressArea
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressArea_Tooltip,
        id: _models.TranslationKey.AddressArea_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressArea_Placeholder),
      isAddressMatchRequired: configAddress?.area?.validation?.isAddressMatchRequired,
      isEditable: !!(canEdit && configAddress?.area?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.area?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.locality,
      name: "address.locality",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressLocality,
        id: _models.TranslationKey.AddressLocality
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressLocality_Tooltip,
        id: _models.TranslationKey.AddressLocality_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressLocality_Placeholder),
      isAddressMatchRequired: configAddress?.locality?.validation?.isAddressMatchRequired,
      isEditable: !!(canEdit && configAddress?.locality?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.locality?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.district,
      name: "address.district",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDistrict,
        id: _models.TranslationKey.AddressDistrict
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressDistrict_Tooltip,
        id: _models.TranslationKey.AddressDistrict_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressDistrict_Placeholder),
      isAddressMatchRequired: configAddress?.district?.validation?.isAddressMatchRequired,
      isEditable: !!(canEdit && configAddress?.district?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.district?.validation?.isMandatory,
      customErrors: customErrors
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
      ...configAddress?.region,
      name: "address.region",
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressRegion,
        id: _models.TranslationKey.AddressRegion
      }),
      helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.AddressRegion_Tooltip,
        id: _models.TranslationKey.AddressRegion_Tooltip
      }),
      customPlaceholder: formatMessage(_models.TranslationKey.AddressRegion_Placeholder),
      isAddressMatchRequired: configAddress?.region?.validation?.isAddressMatchRequired,
      isEditable: !!(canEdit && configAddress?.region?.isEditable),
      useUpperCase: useUpperCaseAddress,
      isMandatory: configAddress?.region?.validation?.isMandatory,
      customErrors: customErrors
    })]
  });
};
exports.AddressSection = AddressSection;
//# sourceMappingURL=AddressSection.js.map